module.exports = __webpack_public_path__ + "img/galeria-especie-exotica-13.ae25696f.jpg";